import React from 'react';
import  "./App.css";
import SimpleButtonNavigation from './Components/MainNav'
import Header from './Components/Header'
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Container } from '@material-ui/core';
import Trending from './Pages/Trending/Trending'
import Movies from './Pages/Movies/Movies';
import Series from './Pages/Series/Series';
import Search from './Pages/Search/Search';

// Exporting the functions


export default function App() {

  return (
    <BrowserRouter>
    <Header/>
    <div className = "app">
    <Container>
    <Switch>
      <Route path = '/' component = {Trending} exact/>
      <Route path = '/movies' component = {Movies}/>
      <Route path = '/series' component = {Series}/>
      <Route path = '/search' component = {Search}/>
    </Switch>
    </Container>
    </div>
    <SimpleButtonNavigation/>
    </BrowserRouter>
  );
}